import React, { useState } from 'react';
import { useSwipeable } from 'react-swipeable';
import './TravelTinder.css';

const dummyUsers = [
  {
    id: 1,
    username: 'Alice',
    photo: 'https://people.com/thmb/kr3h1NnxE82M1U_BWiWjWWNVsoo=/4000x0/filters:no_upscale():max_bytes(150000):strip_icc():focal(999x0:1001x2):format(webp)/Simone-Ashley-052525-1-3936e8f5c29a461aab605b66e7853c78.jpg',
    location: 'New York, USA',
    upcomingTrip: {
      destination: 'Bali, Indonesia',
      dates: 'Aug 15-30, 2024',
      budget: '$1500'
    },
  },
  {
    id: 2,
    username: 'Bob',
    photo: 'https://people.com/thmb/ulCEgUyOtimNCvVcmNCFEU_-_3M=/468x468/filters:no_upscale():max_bytes(150000):strip_icc():focal(999x0:1001x2):format(webp)/phil-robertson-1-5415bc97f0b14dc884e02d6d7ba16991.jpg',
    location: 'Paris, France',
    upcomingTrip: {
      destination: 'Maldives',
      dates: 'Sep 1-15, 2024',
      budget: '$5000'
    },
  },
  {
    id: 3,
    username: 'Charlie',
    photo: 'https://people.com/thmb/BCTD2mTgr9xj0GOvq-9aU1tXp9A=/468x468/filters:no_upscale():max_bytes(150000):strip_icc():focal(671x268:673x270):format(webp)/Jennifer-Lopez-arriving-at-a-UK-Special-Screening-of-Unstoppable-052325-5d00622d992546e992b1266dd59dc17e.jpg',
    location: 'Sydney, Australia',
    upcomingTrip: {
      destination: 'Nepal',
      dates: 'Oct 10-25, 2024',
      budget: '$2000'
    },
  },
  {
    id: 4,
    username: 'Vero',
    photo: 'https://people.com/thmb/BCTD2mTgr9xj0GOvq-9aU1tXp9A=/468x468/filters:no_upscale():max_bytes(150000):strip_icc():focal(671x268:673x270):format(webp)/Jennifer-Lopez-arriving-at-a-UK-Special-Screening-of-Unstoppable-052325-5d00622d992546e992b1266dd59dc17e.jpg',
    location: 'Sydney, Australia',
    upcomingTrip: {
      destination: 'Nepal',
      dates: 'Oct 10-25, 2024',
      budget: '$2000'
    },
    travelpreference: {
      style_label: 'Adventure',
      interests: ['Skydiving', 'Surfing', 'Cliff Diving'],
      pace: 'Fast'
    }
  }
];

const TravelSwipe = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [matches, setMatches] = useState([]);
  const [swipePosition, setSwipePosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const totalCardsToShow = 3; // Number of cards to show in stack

  const handleSwipe = (direction) => {
    const action = direction === 'Right' ? 'YES' : 'NOPE';
    if (action === 'YES') setMatches(prev => [...prev, dummyUsers[currentIndex]]);
    setCurrentIndex(prev => prev + 1);
  };

  const handlers = useSwipeable({
    onSwiping: (e) => {
      setSwipePosition({ x: e.deltaX, y: e.deltaY });
      setIsDragging(true);
    },
    onSwiped: (e) => {
      if (e.dir === 'Left' || e.dir === 'Right') {
        handleSwipe(e.dir);
      }
      setSwipePosition({ x: 0, y: 0 });
      setIsDragging(false);
    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
    delta: 10
  });

  if (currentIndex >= dummyUsers.length) {
    return (
      <div className="no-more-users">
        <h2>You've swiped through everyone!</h2>
        <button onClick={() => setCurrentIndex(0)} className="restart-button">Start Over</button>
      </div>
    );
  }

  const HowItWorks = () => (
    <div className="text-center">
      <h5
        style={{
          fontWeight: '800',
          background: 'linear-gradient(45deg, #4A90E2, #FEB47B)',
          WebkitBackgroundClip: 'text',
          color: 'transparent',
          marginBottom: '16px',
        }}
        className="text-2xl font-semibold mb-6 text-gray-800"
      >
        Find Your Perfect Travel Companion
      </h5>
      <hr />

      <div className="progress-container mb-3">
        <div className="step-container">
          <div className="step-circle step-circle--lg">1</div>
          <span className="step-label">Swipe</span>
        </div>
        <div className="dotted-line dotted-line--lg"></div>
        <div className="step-container">
          <div className="step-circle step-circle--md">2</div>
          <span className="step-label">Match</span>
        </div>
        <div className="dotted-line dotted-line--md"></div>
        <div className="step-container">
          <div className="step-circle step-circle--sm">3</div>
          <span className="step-label">Travel</span>
        </div>
      </div>
    </div>
  );

  return (
    <div className="travel-app">
      <HowItWorks />
      <div className="cards-stack-container">
        {dummyUsers
          .slice(currentIndex, currentIndex + totalCardsToShow)
          .map((user, index) => {
            const isTopCard = index === 0;
            const cardStyle = {
              zIndex: totalCardsToShow - index,
              transform: isTopCard
                ? `translate(${swipePosition.x}px, ${swipePosition.y}px) rotate(${swipePosition.x / 15}deg)`
                : `translateY(${index * 15}px) scale(${1 - index * 0.05})`,
              transition: isTopCard && !isDragging
                ? 'transform 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28)'
                : 'none',
              opacity: 1 - (index * 0.2),
            };

            return (
              <div 
                key={`${user.id}-${currentIndex + index}`}
                className={`user-card ${isTopCard ? 'top-card' : ''}`}
                style={cardStyle}
                {...(isTopCard ? handlers : {})}
              >
<div className="card-image-container">
                  <img 
                    src={user.photo} 
                    alt={user.username} 
                    className="card-image"
                  />
                  <div className="image-overlay">
                    {isTopCard && (
                    <>
                      <div 
                        className="swipe-text like-text text-white" 
                        style={{ opacity: swipePosition.x > 50 ? 1 : 0 }}
                      >
                        YES
                      </div>
                      <div 
                        className="swipe-text nope-text text-white" 
                        style={{ opacity: swipePosition.x < -50 ? 1 : 0 }}
                      >
                        NOPE
                      </div>
                    </>
                  )}
                  </div>
                </div>
                <div className="card-content">
                  <div className="card-header">
                    <h2 className='text-white'>{user.username}</h2>
                    <div className="location">{user.location}</div>
                  </div>
                  <div className="trip-info">
                    <h4>Upcoming Trip</h4>
                    <p>📍 {user.upcomingTrip.destination}</p>
                    <p>📅 {user.upcomingTrip.dates}</p>
                    <p>💰 {user.upcomingTrip.budget}</p>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default TravelSwipe;